import { format } from 'date-fns';


export function isValidDate(val: string) {
    if (!val) {
        return true;
    }

    if (!Date.parse(val)) {
        return 'Invalid date';
    }

    return format(new Date(val), 'y').length === 4 || 'Date must be in format mm/dd/yyyy';
}
